// extracted by mini-css-extract-plugin
export default {"container":"lessons_container__aL532","lessonsContent":"lessons_lessonsContent__FZTjv"};